import { currencyStyle, inputInPence } from '@utils/currencyFormatter';

import styles from './Variance.module.scss';

export interface VarianceProps {
  customHeader?: string;
  varianceValue?: string;
}

export const Variance = ({ customHeader, varianceValue }: VarianceProps) => {
  if (!customHeader && !varianceValue) {
    return null;
  }

  return (
    <>
      <div className={styles.customHeader}>
        {customHeader && (
          <span>
            {customHeader}
            <span className={`${currencyStyle(Number(inputInPence(varianceValue || '')))}`}>
              {varianceValue}
            </span>
          </span>
        )}
      </div>
    </>
  );
};
